module.exports = {"FIADDCARD":"credit-debit-cards","TXNPMTDCLN":"error"}